module.exports = __webpack_public_path__ + "img/icon.fa1c24de.png";